import ismobile from './ismobile';
import nowbrowser from './nowbrowser';
import vendorprefix from './vendorprefix';
import environment from './environment';
import gamename from './gamename';

export default {
    ismobile,
    nowbrowser,
    vendorprefix,
    environment,
    gamename,
    info: {
        ismobile: ismobile(),
        nowbrowser: nowbrowser(),
        vendorprefix: vendorprefix(),
        environment: environment(),
        game: gamename()
    }
};